<template>
  <v-card color="#F5F5F5" class="back pa-2 mt-0 report-card">
    <v-card-title
      >1.7 -
      {{ $t('Serviços Solicitados x Concluídos - Período') }}</v-card-title
    >
    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!showChart">
      {{ $t('Nenhum serviço encontrado') }}
    </v-alert>
    <v-card-text v-else>
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6">
          <HorizontalBarChart
            :chart-data="solicitedVConcluedChartData"
            :options="options"
          />
          <!-- <GChart
            type="BarChart"
            :data="googleChartData"
            :options="opt"
            v-if="haveResponse"
          />
          <TNoContent v-else /> -->
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <PieChart
            :chartData="pieChartData"
            :options="optionsPie"
            :plugins="plugins"
          />
        </v-col>
      </v-row>

      <div class="wrapper">
        <v-data-table
          :loading="loading"
          loading-text="Carregando..."
          no-data-text="Nenhum dado encontrado"
          :headers="requestSolicitedConcluedHeader"
          :items="solicitedVConclued"
          class="main-table"
          hide-default-footer
          hide-default-header
          :header-props="headerProps"
          :items-per-page="pageSize"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:[`item.osType`]="{ item }">
            {{ item.serviceOrderType }}
          </template>

          <template v-slot:[`item.solicited`]="{ item }">
            {{ item.totalRequestedServices }}
          </template>

          <template v-slot:[`item.conclued`]="{ item }">
            {{ item.totalCompletedServices }}
          </template>
        </v-data-table>
        <div class="pagination">
          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="page"
              :length="totalPages"
              :total-visible="3"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<style scoped lang="scss">
@import '@/sass/variables.scss';
.wrapper {
  padding: 0.5rem;

  .v-data-table {
    &::v-deep .v-data-table__wrapper {
      table {
        td {
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
  .table-custom {
    &::v-deep .v-data-table__wrapper {
      thead {
        border: none !important;

        th {
          border: none !important;
          &:first-child {
            border-radius: 4px 0 0 4px;
          }

          &:last-child {
            border-radius: 0 4px 4px 0;
          }
        }
      }
    }
  }

  .pagination {
    margin: 1.5rem 0;
    background: $grey-1;
    border-radius: 4px;
    padding: 0.3rem 1.3rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .item-pagination {
      flex: 1 1 100px;
      margin: 0.5rem 0;
      .btn {
        border-radius: 4px;
        background: #c7c9ca;
        font-weight: bold;
      }
      .registros {
        span {
          font-weight: 700;
          font-size: 12px;
          line-height: 16px;
          color: $grey-2;
        }
      }
    }
    .block-one {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .block-two {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .pagination-item {
        &::v-deep .v-pagination {
          li {
            button {
              box-shadow: none !important;
              background: none !important;
              color: $grey-2;
              font-weight: 500;
            }

            .v-pagination__item--active {
              color: $black-1;
            }
          }
        }
      }
    }

    @media (max-width: 406px) {
      .block-one {
        justify-content: center;
      }
      .block-two {
        justify-content: center;
      }
    }
  }
}

.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
</style>

<script>
import ChartDataLabels from 'chartjs-plugin-datalabels'
import ApiService from '../../../../../../services/ApiService'
import HorizontalBarChart from '../../../../Reports/components/charts/horizontalBarChart'
import PieChart from '../../../../Reports/components/charts/pieChart'

export default {
  props: {
    filter: Object,
  },
  components: {
    HorizontalBarChart,
    PieChart,
  },

  data() {
    return {
      apiService: new ApiService(),
      showChart: true,
      loading: false,
      solicitedVConclued: undefined,
      page: 1,
      haveResponse: false,
      googleChartData: [],
      opt: {
        colors: ['#212950', '#C4E8F2'],
        legend: {
          position: 'top',
        },
        hAxis: {
          minValue: 0,
        },
      },
      totalPages: 1,
      pageSize: 10,
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
      },
      optionsPie: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
              size: 11,
            },
          },
        },
      },
      solicitedVConcluedChartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      totalSolicited: [],
      totalConclued: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      requestSolicitedConcluedHeader: [
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'osType',
        },
        {
          text: 'Solicitadas',
          align: 'center',
          value: 'solicited',
        },
        {
          text: 'Concluídas',
          align: 'center',
          value: 'conclued',
        },
        {
          text: 'Pendentes',
          align: 'center',
          value: 'pendents',
        },
      ],
      quantity: [],
      backgroundColors: [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ],
      total: 0,
    }
  },

  async created() {
    this.listSolicitedVConclued()
  },

  methods: {
    async listSolicitedVConclued() {
      await this.apiService
        .post('bigData/requestedCompletedServices', this.filter)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.solicitedVConclued = []
          this.labels = []
          this.quantity = []
          this.totalSolicited = []
          this.totalConclued = []
          this.googleChartData = []

          this.showChart = response.content.objects.length > 0

          response.content.objects.map((value) => {
            let changedServiceOrderType = this.switchValue(
              value.serviceOrderType
            )
            value.serviceOrderType = changedServiceOrderType
            let pendents =
              value.totalRequestedServices - value.totalCompletedServices
            this.solicitedVConclued.push({ ...value, pendents })
          })

          this.getBackgroundColors(response.content.chartsModel.length)
          response.content.chartsModel.map((obj) => {
            this.labels.push(obj.name)
            this.quantity.push(obj.quantity)
          })

          let totalSolicitedCounter = 0
          let totalCompletedCounter = 0

          this.haveResponse = response.content.objects

          response.content.objects.map((obj) => {
            totalSolicitedCounter += obj.totalRequestedServices
            totalCompletedCounter += obj.totalCompletedServices
          })

          this.totalSolicited.push(totalSolicitedCounter)
          this.totalConclued.push(totalCompletedCounter)

          if (this.haveResponse) {
            this.googleChartData.push([
              'QTD.',
              totalSolicitedCounter,
              totalCompletedCounter,
            ])
            this.googleChartData.unshift([
              this.$t('Números'),
              this.$t('Total solicitado'),
              this.$t('Total concluído'),
            ])
          }
        })

        .catch((err) => {})

      this.fillSolicitedVConcluedChartData()
      this.fillPieChart()
    },
    fillSolicitedVConcluedChartData() {
      this.solicitedVConcluedChartData = {
        labels: [''],
        datasets: [
          {
            label: 'Tot. Solicitadas',
            data: this.totalSolicited,
            backgroundColor: '#212950',
          },
          {
            label: 'Tot. Concluídas',
            data: this.totalConclued,
            backgroundColor: '#BBCF20',
          },
        ],
      }
    },
    fillPieChart() {
      this.pieChartData = {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            label: '',
            data: this.quantity,
            pointRadius: 5,
            datalabels: {
              anchor: 'center',
              display: true,
              formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map((data) => {
                  sum += data
                })
                let percentage = ((value * 100) / sum).toFixed(0) + '%'
                return percentage
              },
              color: '#fff',
            },
          },
        ],
      }
    },
    getBackgroundColors(length) {
      this.backgroundColors = [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ]

      for (let i = 0; i < length; i++) {
        this.backgroundColors.push(
          `#${Math.floor(Math.random() * 16777215).toString(16)}`
        )
      }
    },
    switchValue(val) {
      switch (val) {
        case 0:
          return this.$t('Treinamento')
        case 1:
          return this.$t('Segurança elétrica')
        case 2:
          return this.$t('Preventiva')
        case 3:
          return this.$t('Instalação')
        case 4:
          return this.$t('Rotina de Inspeção')
        case 5:
          return this.$t('Corretiva')
        case 6:
          return this.$t('Calibração')
        case 7:
          return this.$t('Validação/Qualificação')
        case 8:
          return this.$t('Serviços Administrativos')
      }
    },

    printUniqueResults(arrayOfObj, key) {
      // essa função remove os indices repetidos do array
      return arrayOfObj.filter((item, index, array) => {
        return array.map((mapItem) => mapItem[key]).indexOf(item[key]) === index
      })
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.listSolicitedVConclued()
    },
  },
}
</script>
